import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=547a8f7d&scoped=true&lang=pug"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"
import style0 from "./FullPage.vue?vue&type=style&index=0&id=547a8f7d&prod&lang=css"
import style1 from "./FullPage.vue?vue&type=style&index=1&id=547a8f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a8f7d",
  null
  
)

export default component.exports